export class CustomError extends Error {
  public code: number | string
  public data?: any

  constructor(message: string, code: number | string, data?: any) {
    super(message)
    this.code = code
    this.data = data
    Object.setPrototypeOf(this, CustomError.prototype)
  }
}
